import { Routes } from '@angular/router';
import { adminGuard } from './core/admin.guard';

export const routes: Routes = [
  {
    path: 'session-handoff',
    loadComponent: () => import('./features/crm-session.component').then(component => component.CrmSessionComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login.component').then((component) => component.LoginComponent),
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./features/admin-shell.component').then((component) => component.AdminShellComponent),
  },
  { path: '', pathMatch: 'full', redirectTo: 'admin' },
  { path: '**', redirectTo: 'admin' },
];
